jQuery(document).ready(function($){
  $('.testimonial-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    prevArrow:$('.prev'),
    nextArrow:$('.next') ,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
        {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
});

// gallery slider images
jQuery(document).ready(function ($) {
  if (window.matchMedia('(min-width: 576px)').matches) {
    $('.liefde-wrp').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,
      prevArrow: $('.prev2'),
      nextArrow: $('.next2'),
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    });
  }
});

// features slider for mob
jQuery(document).ready(function ($) {
  if (window.matchMedia('(max-width: 575px)').matches) {
$('.feature-badges').slick({
  // slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  cssEase: 'linear',
  pauseOnHover: false,
  pauseOnFocus: false,
  variableWidth: true   
});
  }
});

//  continous vertical slider 
  $(document).ready(function () {
    $(".proof-slider").slick({
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 3,         
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,         
      speed: 5000,              
      cssEase: "linear",      
      arrows: false,
      dots: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipe: false,            
      touchMove: false,
          responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
        {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    });
  });

 
// 
jQuery(document).ready(function($){
  $('.review-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    prevArrow:$('.prev2'),
    nextArrow:$('.next2') ,
  });
});
// product slider
jQuery(document).ready(function ($) {
  $('.maat-logos').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,   
    speed: 4000,        
    cssEase: 'linear', 
    pauseOnHover: false,
    pauseOnFocus: false,
       responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });
});
// animation book
$(document).ready(function () {
  const $wrapper = $('.relationship-wrapper');
  const $bookImg = $('.book-img');

  if (!$wrapper.length || !$bookImg.length) return;

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        $bookImg.addClass('animate');
        observer.unobserve(entry.target); // run once
      }
    });
  }, {
    threshold: 0.3
  });

  observer.observe($wrapper[0]);
});

jQuery(document).ready(function ($) {
  $('.review-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    appendDots: '.review-dots',
    infinite: false,
    adaptiveHeight: true
  });

});
// swiper code start here 
let liefdeSwiper;
function updateReview(swiper) {
  const slide = swiper.slides[swiper.activeIndex];
  document.getElementById("reviewImg").src = slide.dataset.reviewImage;
  document.getElementById("reviewText").innerText = slide.dataset.reviewText;
  document.getElementById("reviewStars").innerHTML =
    "★".repeat(slide.dataset.reviewStars);
  document.getElementById("reviewDate").innerText = slide.dataset.reviewDate;
}

function initLiefdeSwiper() {
  if (!liefdeSwiper) {
    liefdeSwiper = new Swiper(".liefdeBigSwiper", {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: ".liefde-next",
        prevEl: ".liefde-prev"
      },
      pagination: {
        el: ".liefde-pagination",
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 4
        }
      },
      on: {
        init: updateReview,
        slideChange: updateReview
      }
    });
  }
}

window.addEventListener("load", initLiefdeSwiper);
// swiper code end here 

// video section code start here
document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('[data-video]');

  containers.forEach(container => {
    const playBtn = container.querySelector('[data-play]');
    const poster = container.querySelector('[data-poster]');
    const video = container.querySelector('video');

    if (playBtn && poster && video) {
      playBtn.addEventListener('click', () => {
        poster.style.display = 'none';
        container.classList.remove('activeimage');
        video.play();
      });
    }
  });
});
// video section code end here


// product page review tab code start here 
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tab-btn');
  const reviews = document.querySelectorAll('.review-card');
  function showTab(tabId) {
    reviews.forEach(review => {
      review.style.display =
        review.dataset.tab === tabId ? 'block' : 'none';
    });
  }
  if (tabs.length) {
    const firstTab = tabs[0];
    showTab(firstTab.dataset.tab);
  }
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      showTab(tab.dataset.tab);
    });
  });
});
// product page review tab code end here 

// product page checkbox price change code start here
jQuery(document).ready(function () {
  var defaultPrice = $("#main-product-price").text().trim();
  var defaultPillText = $(".pill-text").text().trim();
  function applyPrice(isChecked) {
    if (isChecked) {
      var price = $(".price-main").text().trim();
      var saveprice = $(".save-pill").text().replace("Bespaar", "").trim();
      $("#main-product-price").text(price);
      $(".pill-price").text(price);
      var data = $(".pill-text").text();
      $(".pill-text").text(data.replace(/\d+%/, saveprice));
    } else {
      $("#main-product-price").text(defaultPrice);
      $(".pill-price").text(defaultPrice);
      $(".pill-text").text(defaultPillText);

    }
  }
  $(document).on("change", ".double-qty-checkbox", function (e) {
    e.stopPropagation();
    applyPrice(this.checked);
  });
  $(document).on("click", ".double-qty-card", function (e) {
    if ($(e.target).is("input")) return;
    var checkbox = $(this).find(".double-qty-checkbox");
    checkbox.prop("checked", !checkbox.prop("checked")).trigger("change");

  });
});
// product page checkbox price change code end here


// Let's take a look at the game section code start here 
document.addEventListener("DOMContentLoaded", function () {
  const accordionItems = document.querySelectorAll(".accordion-item");
  const plusIcons = document.querySelectorAll(".p1");
  let currentIndex = 0;
  let interval = null;
  function clearAll() {
    accordionItems.forEach(item => item.classList.remove("active"));
    plusIcons.forEach(icon => icon.classList.remove("active"));
  }
  function openAccordion(index) {
    clearAll();
      document.querySelectorAll(".progress-bar span").forEach(span => {
    span.style.animation = "none";
    span.offsetHeight;
    span.style.animation = "";
  });
    if (accordionItems[index]) {
      accordionItems[index].classList.add("active");
    }
    if (plusIcons[index]) {
      plusIcons[index].classList.add("active");
    }

    currentIndex = index;
  }

  function startAutoPlay() {
    interval = setInterval(() => {
      let next = currentIndex + 1;
      if (next >= accordionItems.length) next = 0;
      openAccordion(next);
    }, 4000);
  }
  openAccordion(0);
  startAutoPlay();

});
jQuery(".plus_icon").click(function () {
  let dataattribute = jQuery(this).data("accordion");
  jQuery(".accordion-item").each(function () {
    let dataindex = jQuery(this).data("index");
    if (dataattribute == dataindex) {
      jQuery(this).toggleClass("active");
    } else {
      jQuery(this).removeClass("active");
    }
  });

  jQuery(".plus_icon").each(function () {
    let iconIndex = jQuery(this).data("accordion");
    if (iconIndex == dataattribute) {
      jQuery(this).toggleClass("active");
    } else {
      jQuery(this).removeClass("active");
    }
  });

});

 document.querySelectorAll('.accordion-toggle').forEach((button) => {
  button.addEventListener('click', () => {
    const item = button.parentElement;
    document.querySelectorAll('.accordion-item').forEach(acc => {
      if (acc !== item) {
        acc.classList.remove('active');
        const span = acc.querySelector('.progress-bar span');
        if (span) span.style.animation = 'none';
      }
    });
    item.classList.toggle('active');
    const progressSpan = item.querySelector('.progress-bar span');
    if (progressSpan) {
      progressSpan.style.animation = 'none';
      progressSpan.offsetHeight; // reflow
      progressSpan.style.animation = '';
    }
  });
});
  // Let's take a look at the game section code end here 

// product page gallary code start here 
document.addEventListener('DOMContentLoaded', function () {
  const mainImage = document.getElementById('mainProductImage');
  const thumbs = document.querySelectorAll('.thumbnail-img');
  const thumbRow = document.getElementById('thumbRow');
  const prevBtn = document.querySelector('.thumb-nav.prev');
  const nextBtn = document.querySelector('.thumb-nav.next');
  thumbs.forEach((thumb) => {
  thumb.addEventListener('click', function () {
    mainImage.style.opacity = '0';
    setTimeout(() => {
      mainImage.src = this.dataset.full;
      mainImage.style.opacity = '1';
    }, 150);
    thumbs.forEach(t => t.classList.remove('active'));
    this.classList.add('active');
  });
});
  if (thumbs.length > 4) {
    prevBtn.style.display = 'flex';
    nextBtn.style.display = 'flex';
  } else {
    prevBtn.style.display = 'none';
    nextBtn.style.display = 'none';
  }
  const scrollAmount = 120;
  nextBtn.addEventListener('click', () => {
    thumbRow.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });
  prevBtn.addEventListener('click', () => {
    thumbRow.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });
});
// product page gallary code end here 